import { useEffect, useState } from "react";
import { TaskRow } from "../../assets/utils/table-types";
import StatisticBlock, {
  DataStatisticProps,
} from "../../components/ui/statistics-block";
import getData from "../../api/project-request";
import AppLayout from "../../components/layout/app/layout";
import Headline from "../../components/ui/headline";
import { HeadlineTypeEnum } from "../../assets/utils/enums/headline";
import { ThemeTypeEnum } from "../../assets/utils/validation/types";
import lightTaskIcon from "../../assets/images/icons/light/tasks-icon.svg";
import darkTaskIcon from "../../assets/images/icons/dark/tasks-icon.svg";
import { COLORS } from "../../assets/utils/enums/colors";
import DataTable from "../../components/ui/table";
import { tableColumnType, TableTypeEnum } from "../../assets/utils/enums/table";
import { API_URL_TASK } from "../../constants";
import { PriorityEnum } from "../../assets/utils/enums/project";
import { deleteArrFunc } from "../../assets/utils/request-function";
import { useStatisticPeriod } from "../../assets/store/useStatisticPeriod";

export default function TaskMainPage() {
  const [tasks, setTasks] = useState<TaskRow[]>([]);
  const [taskStatistic, setTaskStatistic] = useState<DataStatisticProps[]>([]);
  const [prioritiesStatistic, setPrioritiesStatistic] = useState<
    DataStatisticProps[]
  >([]);
  const [loaderState, setLoaderState] = useState<boolean>(false);
  const [isDeleted, setIsDeleted] = useState<boolean>(false);
  const { period } = useStatisticPeriod();

  const getTasks = async () => {
    setLoaderState(true);
    try {
      const data = await getData(
        `${API_URL_TASK}/get-all-tasks-by-authorized-user`
      );
      if (Array.isArray(data)) {
        setTasks(
          data.map(
            (item): TaskRow => ({
              isChecked: false,
              id: item.id,
              name: item.name || "",
              description: item.description || "",
              deadline: item.deadline || "",
              status: item.status,
              priorityName: item.priority ?? PriorityEnum.LOW,
              createdAt: item.createdAt || "",
              createdBy: item.responsibleEmail || "",
              usersEmails:
                item.users.map((item: { email: string; fullName: string }) => ({
                  email: item.email,
                })) || [],
              project: item.project || "",
              projectId: item.projectId,
              selling: item.selling || "",
              sellingId: item.sellingId,
            })
          )
        );
      } else {
        setTasks([]);
      }
    } catch (error: any) {
      console.log(error.message);
      setTasks([]);
    } finally {
      setTimeout(() => {
        setLoaderState(false);
      }, 100);
    }
  };

  useEffect(() => {
    getTasks();
  }, []);

  useEffect(() => {
    getTasks();
    setIsDeleted(false);
  }, [isDeleted]);

  useEffect(() => {
    const getStatisticProject = async () => {
      const data = await getData(
        `${API_URL_TASK}/tasks-summary?period=${period}`
      );
      setTaskStatistic([
        {
          title: "Створені",
          value: data.totalCreated,
          percent: "",
        },
        {
          title: "Виконані",
          value: data.completed,
          percent: "",
        },
        { title: "В процесі", value: data.inProgress, percent: "" },
      ]);
    };
    const getStatisticPriority = async () => {
      const data = await getData(
        `${API_URL_TASK}/priority-summary?period=${period}`
      );
      setPrioritiesStatistic(
        data.priorities.map(
              (item: any): DataStatisticProps => ({
                title: item.priority,
                value: item.total,
                percent: `Виконано ${item.completed} (${item.completedPercentage})`,
              })
            )
      );
    };
    setLoaderState(true);

    setTimeout(() => {
      getStatisticProject();
      getStatisticPriority();
      setLoaderState(false);
    }, 200);
  }, [period, isDeleted]);

  return (
    <AppLayout className="" blockType="projects" loaderState={loaderState}>
      <Headline
        headline={HeadlineTypeEnum.TASKS}
        theme={ThemeTypeEnum.LIGHT}
        btn_text="Додати завдання"
        btn_link="/tasks/add"
        isEdit={false}
      />
      <div
        data-class="statistics-block"
        className="w-100 flex-wrap"
      >
        <StatisticBlock
          key={4}
          iconColor={COLORS["light-bg-color"]}
          iconUrl={lightTaskIcon}
          bgColor={COLORS.white}
          isDropdown={true}
          data={taskStatistic}
        />
        <StatisticBlock
          key={6}
          iconColor={COLORS.main2}
          iconUrl={darkTaskIcon}
          bgColor={COLORS.white}
          isDropdown={true}
          data={prioritiesStatistic}
          statsTitle="Пріорітетність завдань"
        />
      </div>
      <DataTable
        table={tableColumnType[TableTypeEnum.TASKS]}
        data={tasks}
        deleteArrFunc={(queryArr) =>
          deleteArrFunc(queryArr, `${API_URL_TASK}/`, setIsDeleted)
        }
      />
    </AppLayout>
  );
}
